import React from 'react'
import {
    Route,
} from 'react-router-dom'
import {getUserInfo} from '../actions'
import {Button, Horizontal, Image, Vertical} from "../../../components/index";
import HomeScreen from "./HomeScreen";
import DetailScreen from "./DetailScreen";
import ProductionTypeScreen from "./product/ProductionTypeScreen";
import ProductListScreen from "./product/ProductListScreen";
import {connect} from "react-redux";
import wx from '../../../utils/wxUtils'
import {downloadApp} from '../utils'
import ManuscriptDetailScreen from "./ManuscriptDetailScreen";
import {matchPath} from 'react-router'
import {loginByWxUnionId} from '../actions'
import axios from 'axios'
import {actionAPI} from '../apis'

class App extends React.Component {
    state = {
        showWxModal: false,
        showPhoneModal: false,
        showXcxModal: false,
        ownerInfo: null,
        qRCode: null,
        workPhone: '',
        wxNum: ''
    };

    componentWillMount() {
        this.init()
    }

    async init() {

        let res2 = await this.props.loginByWxUnionId();
        if (res2.isOk){

            await this.setState({ownerInfo: res2.data.data})
        }

        const res = await this.props.getUserInfo(this.props.match.params._id);
        if (res.isOk) {
            this.initWx();
        }
    }

    showXcxModal() {
        if (this.state.showXcxModal)
            return <div className={'modal'} onClick={() => this.setState({showXcxModal: false})}>

                <div className={'wx_content'} style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingBottom: 20,
                }}>
                    <Image source={{uri: this.state.qRCode}} style={{
                        width: 200,
                        height: 200,
                        marginTop: 25,
                        marginBottom: 25,
                    }}/>
                    <div className={'tips'}>扫码查看纹身师联系方式</div>
                </div>
            </div>
    }

    renderWXModal() {
        if (this.state.showWxModal)
            return <div className={'modal'} onClick={() => this.setState({showWxModal: false})}>

                <div className={'wx_content'} onClick={(e) => e.stopPropagation()}>
                    <div className={'header'}>店主微信号</div>
                    <div className={'body'}>
                        <div className={'wx'}>{this.state.wxNum}</div>
                        <div style={{
                            color: '#959595',
                            fontSize: 13,
                            marginBottom: 19,
                            display: 'flex',
                            flexDirection: 'row'
                        }}>今天还可查看<div style={{
                            color: '#ff7700',
                            fontSize: 13,
                        }}>{this.props.userInfo.remainGetWx}</div>纹身师微信</div>
                        <div className={'tips'}>(长按上面文字复制)</div>
                    </div>
                </div>
            </div>
    }

    renderPhoneModal() {
        if (this.state.showPhoneModal)
            return <div className={'modal'} onClick={() => this.setState({showPhoneModal: false})}>

                <div className={'wx_content'} onClick={(e) => e.stopPropagation()}>
                    <div className={'header'}>店主手机号</div>
                    <div className={'body'}>
                        <div className={'wx'}>{this.state.workPhone}</div>
                        <div  style={{
                            color: '#959595',
                            fontSize: 13,
                            marginBottom: 19,
                            display: 'flex',
                            flexDirection: 'row'
                        }}>今天还可查看<div style={{
                            color: '#ff7700',
                            fontSize: 13,
                        }}>{this.props.userInfo.remainGetPhone}</div>个纹身师手机号</div>
                        <div className={'tips'}>(长按上面文字复制)</div>
                    </div>
                </div>
            </div>
    }


    renderLoading() {
        return <Vertical style={splash.root}>
            <Image source={require('../assets/loading.gif')} style={splash.loading}/>
        </Vertical>
    }

    toOrder = () => {
        location.href = 'http://m.wenshendaka.com/wsdk/?storeId=' + this.props.userInfo.userId + '#!/appoint/'
    };

    render() {
        if (!this.props.userInfo.userId)
            return this.renderLoading();

        return (
            <Vertical>
                <Route path="/:_id/manuscript/:_pid" component={ManuscriptDetailScreen}/>
                <Route path="/:_id/detail/:_pid" component={DetailScreen}/>
                <Route path="/:_id/productionType" component={ProductionTypeScreen}/>
                <Route path="/:_id/productList/:_pid" component={ProductListScreen}/>
                <Route path="/:_id"
                       exact={true}
                       component={HomeScreen}/>
                {this.renderFooter()}
                {this.renderWXModal()}
                {this.renderPhoneModal()}
                {this.showXcxModal()}
            </Vertical>
        );
    }

    initWx() {
        wx.init().then(res => {
            wx.showMenuItems({
                menuList: [
                    'menuItem:share:timeline',
                    'menuItem:share:appMessage',
                    'menuItem:favorite',
                    "menuItem:copyUrl",
                    "menuItem:openWithQQBrowser",
                    "menuItem:openWithSafari",
                    "menuItem:editTag"
                ]
            });

            const location = global.location;
            const shareConfig = {
                link: location.origin + location.pathname + '#/' + this.props.userInfo.userId,
                title: this.props.userInfo.nickname + '的作品集',
                desc: '快来给我点赞吧！',
                imgUrl: 'http://img.meizhanggui.cc/logo_wx_share.jpg',
            };

            wx.onMenuShareAppMessage(shareConfig)
            wx.onMenuShareTimeline(shareConfig)
        });
    }

    renderFooter() {
        if (this.props.userInfo && !(matchPath(this.props.location.pathname, "/:_id/manuscript/:_pid", true) || matchPath(this.props.location.pathname, "/:_id/productionType", true) || matchPath(this.props.location.pathname, "/:_id/productList/:_pid", true)))
            return <Horizontal className={'footer'}>
                <Horizontal className={'content'}>
                    <Button className={'phone btn'} onClick={async () => {

                        if (!this.getIsWxClient()) {
                            this._showXcx()
                            return
                        }

                        const code = getQuery('code');  //如果存在的话，是授权页过来
                        const lastCode = localStorage.lastCode;
                        if (!this.state.ownerInfo) {
                            this.authWeixin()
                            return
                        }

                        if (this.props.userInfo.remainGetPhone == 0) {

                            toast('今天查看纹身师手机号次数已用完\n请明天再次尝试')
                            return
                        }

                        let res = await actionAPI(this.props.userInfo.userId, 'clickPhone')
                        if (res.isOk) {
                            this.setState({
                                showPhoneModal: true,
                                wxNum: res.data.data.wxNum,
                                workPhone: res.data.data.workPhone,
                            })
                        } else {
                            toast(res.data.msg)
                        }


                    }}>
                        <Image
                            source={require('../assets/icon_dianhua.png')}
                            style={{
                                width: 13,
                                height: 15,
                                marginRight: 5
                            }}/>查看手机号</Button>
                    <Button className={'weixin btn'} onClick={async () => {
                        if (!this.getIsWxClient()) {
                            this._showXcx()
                            return
                        }

                        const code = getQuery('code');  //如果存在的话，是授权页过来
                        const lastCode = localStorage.lastCode;

                        if (!this.state.ownerInfo) {

                            this.authWeixin()
                            return
                        }

                        if (this.props.userInfo.remainGetWx == 0) {

                            toast('今天查看纹身师微信次数已用完\n请明天再次尝试')
                            return
                        }

                        let res = await actionAPI(this.props.userInfo.userId, 'clickWx')
                        if (res.isOk) {
                            this.setState({
                                showWxModal: true,
                                wxNum: res.data.data.wxNum,
                                workPhone: res.data.data.workPhone,
                            })
                        } else {
                            toast(res.data.msg)
                        }

                    }}>
                        <Image
                            source={require('../assets/icnon_weixin.png')}
                            style={{
                                width: 19,
                                height: 16,
                                marginRight: 5
                            }}/>查看微信</Button>
                </Horizontal>
            </Horizontal>
    }


    _showXcx = async () => {


        let ulrCode = `https://api.wenshendaka.com/new/wx/applet/users/skip/personHomepage/qRCode?userId=${this.props.userInfo.userId}`;
        let qrResult = await axios.get(ulrCode)
        let qRCode = qrResult.data.data.qRCode;

        this.setState({qRCode: qRCode, showXcxModal: true})
    }

    getIsWxClient() {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            return true;
        }
        return false;
    };


    authWeixin() {
        const appid = 'wx951fd2c314e464cd';
        const code = getQuery('code');  //如果存在的话，是授权页过来
        const lastCode = localStorage.lastCode;

        if (!localStorage.unionId)
            if (!code || code == lastCode) {
                // alert('hh  '+location.href)

                const url = location.href.replace(/code=.*&+|state=.*/g, '');

                const redirectUrl = encodeURIComponent(url);
                const authUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid
                    + '&redirect_uri=' + redirectUrl
                    //+ '&response_type=code&scope=snsapi_base'
                    + '&response_type=code&scope=snsapi_userinfo'
                    + '#wechat_redirect';

                location.replace(authUrl);
            } else {
                // alert('xx  '+location.href)
            }

        localStorage.lastCode = code;
    }
}


export default connect((state) => {
    return {
        userInfo: state.app.userInfo,
    }
}, (dispatch) => {
    return {
        loginByWxUnionId: () => dispatch(loginByWxUnionId()),
        getUserInfo: (userId) => {
            return dispatch(getUserInfo(userId))
        }
    }
})(App);


const splash = {
    root: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        justifyContent: 'center',
        alignItems: 'center',
        background: '#fff'
    },

    loading: {
        height: 50,
        width: 80
    }
};



// WEBPACK FOOTER //
// ./src/apps/portfolio/screens/IndexScreen.js